import { render, staticRenderFns } from "./RegistraTempi.vue?vue&type=template&id=403fa607&"
import script from "./RegistraTempi.vue?vue&type=script&lang=js&"
export * from "./RegistraTempi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports